import axios from 'axios';
import Papa from 'papaparse';

const calendarEventsDocument = '1HCw5mXLG8LOQvci6Z7HEVJ89mkIj_A8i3_LhpgN88VQ';

export async function getSignature(address) {
  try {
    const res = await axios.get(`/license-confirmation/signature/get/${address}/`);
    const message = res.data.data?.message;
    const signature = res.data.data?.signature;
    const solAddress = res.data.data?.solAddress;
    return {
      message,
      signature,
      solAddress,
    };
  } catch (e) {
    console.error(e);
    return {};
  }
}

export async function setSolanaWallet(address, solana, signature) {
  try {
    const data = {
      solAddress: solana,
      // eslint-disable-next-line comma-dangle
      signature
    };
    const res = await axios.put(`/license-confirmation/signature/solAddress/${address}/`, data);
    return res?.status === 'SUCCESS' ? res?.data.solAddress : '';
  } catch (e) {
    console.log(e);
    return false;
  }
}

export async function getCalendarEvents() {
  try {
    const res = await axios.get(
      `https://docs.google.com/spreadsheets/d/${calendarEventsDocument}/export?format=csv&gid=0`,
    );
    const { data } = Papa.parse(res.data, {
      header: true,
    });
    return data;
  } catch (e) {
    console.error(e);
    return [];
  }
}
